var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.432 9.51a.75.75 0 0 1 1.057-.078L7 10l-.49.569a.75.75 0 0 1-.078-1.058Zm5.138 3.48 3.927-3.547a.75.75 0 1 1 1.006 1.114l-4.429 4a.75.75 0 0 1-1.006 0c-.73-.662-1.868-1.657-2.827-2.49a545.88 545.88 0 0 0-1.595-1.382l-.135-.117L7 10l.49-.568.136.117a506.182 506.182 0 0 1 1.6 1.385c.76.662 1.641 1.431 2.344 2.057Z",
  fill: "currentColor"
})));
export default SvgChevronDown;